import { handleActions } from 'redux-actions';

import { actions } from '../actions/visibility';

// Destructure the visibility actions.
export const { visibilityHidden, visibilityShown } = actions;

export type VisibilityState = {
  isHidden: boolean;
};

// Init state for the websocket.
const initialState = {
  isHidden: false,
};

// Reducer
export const visibility = handleActions(
  {
    [visibilityHidden.toString()]: (state: VisibilityState) => {
      return { ...state, isHidden: true };
    },
    [visibilityShown.toString()]: (state: VisibilityState) => {
      return { ...state, isHidden: false };
    },
  },
  initialState,
);
